import { useEffect, useState } from "react";
import AHMIS, { API_URL } from "../../../../api/api";
import AddAlertMessage from "../../../../components/alert/Alert";
import { Box, Grid, TextField } from "@mui/material";
import CustomModal from "../../../../components/modal/CustomModal";
import NepaliCalender from "../../../../components/nepali-calender";
import CustomReactSelect from "../../../../components/custom-react-select/CustomReactSelect";
import DeleteRegisterRecordConformation from "../../../../components/delete-register-record-conformation/DeleteRegisterRecordConformation";
import RegisterHeader from "../../../../components/register-header/RegisterHeader";
import { ERROR, ID, MATRA_THOPAMA_OPTIONS, MUAC_OPTIONS, SOMETHING_WENT_WRONG, SUCCESS } from "../../../../utils/constants"
import SwarnaBinduBabaranRegister from "../../../users/components/register/swarna-bindu-register/helper/SwarnaBinduBabaranRegister";
import { AppUtils } from "../../../../utils/appUtils";
import { useSelector } from "react-redux";

const defaultFormData = {
  dartaaMiti: null,
  numberOfDrops: null,
  weightKg: "",
  heightCm: "",
  muac: null,
  nextVisitDate: null,
};

const SwarnaBinduSewaBibaranForm = () => {
  const [showSwarnaBinduModal, setShowSwarnaBinduModal] = useState(false);
  const [modalDefaultValues, setModalDefaultValues] = useState();
  const [formData, setFormData] = useState(defaultFormData);
  const [swarnaBinduSewaBibaranTableData, setSwarnaBinduSewaBibaranTableData] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [totalSize, setTotalSize] = useState(0);
  const [deleteId, setDeleteId] = useState(null);
  const swarnaBinduRegisterId = AppUtils.getUrlParam(ID);
  const { fromDate, toDate, searchParams } = useSelector((state) => state.dateReducer);
  const { rowsPerPage, pageNumber } = useSelector((state) => state.searchFilter);

  useEffect(() => {
    if (showSwarnaBinduModal) {
      if (modalDefaultValues?.id) {
        setFormData({
          dartaaMiti: modalDefaultValues.dartaaMiti || null,
          numberOfDrops: modalDefaultValues.numberOfDrops || null,
          weightKg: modalDefaultValues.weightKg || "",
          heightCm: modalDefaultValues.heightCm || "",
          muac: modalDefaultValues.muac || null,
          nextVisitDate: modalDefaultValues.nextVisitDate || null,
        });
      } else {
        setFormData(defaultFormData);
      }
    }
  }, [showSwarnaBinduModal, modalDefaultValues]);

  const openSwarnaBinduModal = () => {
    setShowSwarnaBinduModal(true);
  };

  const closeSwarnaBinduModal = () => {
    setShowSwarnaBinduModal(false);
    setModalDefaultValues();
    setFormData(defaultFormData);
  };

  const handleDateChange = (name, dateInMilli) => {
    setFormData((prev) => ({ ...prev, [name]: dateInMilli }));
  };

  const handleSelectChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleInputChange = (event) => {
    setFormData((prev) => ({ ...prev, [event.target.name]: event.target.value }));
  };

  const submitSwarnaBinduSewaBibaran = () => {
    if (modalDefaultValues?.id) {
      formData.id = modalDefaultValues.id;
    }
    formData.swarnabinduRegistrationId = swarnaBinduRegisterId;
    const url = `${API_URL.swarnaBinduService}`;
    AHMIS.post(url, formData)
      .then(response => {
        if (response.data.type === SUCCESS) {
          closeSwarnaBinduModal();
          getSwarnaBinduSewaBibaranData(fromDate, toDate);
        }
        AddAlertMessage({ type: response.data.type, message: response.data.message });
      })
      .catch(error => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      });
  };

  useEffect(() => {
    if (fromDate && toDate) {
      getSwarnaBinduSewaBibaranData(fromDate, toDate, searchParams)
    }
  }, [fromDate, toDate, searchParams, rowsPerPage, pageNumber])

  const getSwarnaBinduSewaBibaranData = (fromDate, toDate, searchParams) => {
    let url = `${API_URL.swarnaBinduService}/fromDateRangeAndPage?fromDate=${fromDate}&toDate=${toDate}&pageNumber=${pageNumber}&rowSize=${rowsPerPage}&swarnabinduRegistrationId=${swarnaBinduRegisterId}`;
    if (searchParams) {
      url = url + "&searchParam=" + searchParams;
    }
    AHMIS.get(url)
      .then(response => {
        let jsondata = response.data;
        setSwarnaBinduSewaBibaranTableData(jsondata?.data?.objectList || []);
        setTotalSize(jsondata?.data?.totalSize)
      })
      .catch(error => {
        AddAlertMessage({ type: "error", message: SOMETHING_WENT_WRONG });
      });
  }

  const swarnaBinduSewaBibaranEdit = (id) => {
    AHMIS.get(API_URL.swarnaBinduService + "/" + id)
      .then(response => {
        setModalDefaultValues(response.data?.data);
        setShowSwarnaBinduModal(true);
      }).catch(error => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      })
  }

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
    setDeleteId(null);
  }

  const onDeleteRow = (id) => {
    setShowDeleteModal(true);
    setDeleteId(id);
  }

  const deleteSwarnaBinduSewaBibaranRow = (data) => {
    AHMIS.delete(API_URL.swarnaBinduService + "/" + deleteId + "?deletedReason=" + data.deletedReason)
      .then(response => {
        let jsondata = response.data;
        if (jsondata.type === SUCCESS) {
          setShowDeleteModal(false);
          setDeleteId(null);
          getSwarnaBinduSewaBibaranData(fromDate, toDate);
          AddAlertMessage({ type: jsondata.type, message: jsondata.message });
        } else {
          AddAlertMessage({ type: jsondata.type, message: jsondata.message });
        }
      })
      .catch(error => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      });
  }

  const onHeaderParamChange = (fromDate, toDate, searchParam) => {
    getSwarnaBinduSewaBibaranData(fromDate, toDate, searchParam);
  }

  return (
    <>
      <Box marginTop={2}>
        <RegisterHeader
          registerTitle="सेवा विवरण"
          handleModalOpen={openSwarnaBinduModal}
          getRegisterData={getSwarnaBinduSewaBibaranData}
          onHeaderParamChange={onHeaderParamChange}
          fromDateDefaultFormat
          lazyLoading
          showSearchField
        />
      </Box>
      <CustomModal
        title={modalDefaultValues?.id ? "स्वर्णबिन्दु सेवा विवरण सम्पादन गर्नुहोस्।" : "स्वर्णबिन्दु सेवा विवरणमा नयाँ रेकर्ड थप्नुहोस्।"}
        showModal={showSwarnaBinduModal}
        onModalSubmit={submitSwarnaBinduSewaBibaran}
        onModalClose={closeSwarnaBinduModal}
        maxWidth="lg"
        fullScreen
      >
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={6} md={3}>
            <NepaliCalender
              id="dartaa-miti"
              label="दर्ता मिति"
              name="dartaaMiti"
              defaultDate={formData.dartaaMiti}
              onChange={handleDateChange}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <CustomReactSelect
              label="मात्रा-थोपामा"
              name="numberOfDrops"
              onChange={handleSelectChange}
              options={MATRA_THOPAMA_OPTIONS}
              defaultValue={formData.numberOfDrops}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="तौल (के.जी.)"
              type="number"
              size="small"
              variant="outlined"
              name="weightKg"
              value={formData.weightKg}
              onChange={handleInputChange}
              inputProps={{ min: 0 }}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="उचाइ (से.मि.)"
              type="number"
              size="small"
              variant="outlined"
              name="heightCm"
              value={formData.heightCm}
              onChange={handleInputChange}
              inputProps={{ min: 0 }}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <CustomReactSelect
              label="MUAC"
              name="muac"
              onChange={handleSelectChange}
              options={MUAC_OPTIONS}
              defaultValue={formData.muac}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Box className="postion-relative">
              <NepaliCalender
                id="followUp-Date"
                name="nextVisitDate"
                onChange={handleDateChange}
                label="फर्केर आउने मिति"
                defaultDate={formData.nextVisitDate}
              />
            </Box>
          </Grid>
        </Grid>
      </CustomModal>
      <DeleteRegisterRecordConformation
        showDeleteModal={showDeleteModal}
        closeDeleteModel={closeDeleteModal}
        deleteRecord={deleteSwarnaBinduSewaBibaranRow}
      />
      <SwarnaBinduBabaranRegister
        onEditRow={swarnaBinduSewaBibaranEdit}
        tableData={swarnaBinduSewaBibaranTableData}
        deleteRow={onDeleteRow}
        totalSize={totalSize}
      />
    </>
  );
};

export default SwarnaBinduSewaBibaranForm;